// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Squad In Touch — Spacing, radius, shadow, layout tokens
   4px base grid. The legacy Bootstrap UI was cramped; the new
   system breathes with consistent 8/12/16/24 rhythm.
   ============================================================ */

:root {
  /* spacing scale (4px base) */
  --space-0:  0;
  --space-1:  2px;
  --space-2:  4px;
  --space-3:  8px;
  --space-4:  12px;
  --space-5:  16px;
  --space-6:  20px;
  --space-7:  24px;
  --space-8:  32px;
  --space-9:  40px;
  --space-10: 48px;
  --space-12: 64px;
  --space-16: 96px;

  /* radius */
  --radius-xs:   4px;
  --radius-sm:   6px;
  --radius-md:   8px;    /* inputs, buttons */
  --radius-lg:   12px;   /* cards, menus */
  --radius-xl:   16px;   /* large surfaces, modals */
  --radius-2xl:  20px;
  --radius-pill: 999px;

  /* shadows — soft, cool-tinted, never harsh black */
  --shadow-xs:  0 1px 2px rgba(15, 23, 42, 0.06);
  --shadow-sm:  0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  --shadow-md:  0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.04);
  --shadow-lg:  0 12px 28px rgba(15, 23, 42, 0.12), 0 4px 10px rgba(15, 23, 42, 0.05);
  --shadow-xl:  0 24px 48px rgba(15, 23, 42, 0.16), 0 8px 16px rgba(15, 23, 42, 0.06);
  --shadow-focus: 0 0 0 3px var(--focus-ring);

  /* layout */
  --sidebar-width:     248px;
  --topbar-height:     60px;
  --container-max:     1440px;
  --content-gutter:    24px;

  /* control sizing */
  --control-h-sm: 32px;
  --control-h-md: 38px;
  --control-h-lg: 44px;

  /* motion */
  --ease-out:   cubic-bezier(0.22, 1, 0.36, 1);   /* @kind other */
  --ease-in-out: cubic-bezier(0.45, 0, 0.2, 1);   /* @kind other */
  --dur-fast:   0.12s;   /* @kind other */
  --dur-base:   0.18s;   /* @kind other */
  --dur-slow:   0.28s;   /* @kind other */

  /* z-index */
  --z-sticky:  100;    /* @kind other */
  --z-overlay: 1000;   /* @kind other */
  --z-modal:   1010;   /* @kind other */
  --z-toast:   1100;   /* @kind other */
}
`, "",{"version":3,"sources":["webpack://./src/styles/squad-theme/tokens/layout.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB,KAAK,oBAAoB;EAC3C,mBAAmB,IAAI,iBAAiB;EACxC,mBAAmB,IAAI,2BAA2B;EAClD,mBAAmB;EACnB,oBAAoB;;EAEpB,mDAAmD;EACnD,8CAA8C;EAC9C,gFAAgF;EAChF,iFAAiF;EACjF,mFAAmF;EACnF,mFAAmF;EACnF,2CAA2C;;EAE3C,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;;EAEzB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,WAAW;EACX,4CAA4C,IAAI,gBAAgB;EAChE,4CAA4C,IAAI,gBAAgB;EAChE,mBAAmB,IAAI,gBAAgB;EACvC,mBAAmB,IAAI,gBAAgB;EACvC,mBAAmB,IAAI,gBAAgB;;EAEvC,YAAY;EACZ,gBAAgB,KAAK,gBAAgB;EACrC,iBAAiB,IAAI,gBAAgB;EACrC,iBAAiB,IAAI,gBAAgB;EACrC,iBAAiB,IAAI,gBAAgB;AACvC","sourcesContent":["/* ============================================================\n   Squad In Touch — Spacing, radius, shadow, layout tokens\n   4px base grid. The legacy Bootstrap UI was cramped; the new\n   system breathes with consistent 8/12/16/24 rhythm.\n   ============================================================ */\n\n:root {\n  /* spacing scale (4px base) */\n  --space-0:  0;\n  --space-1:  2px;\n  --space-2:  4px;\n  --space-3:  8px;\n  --space-4:  12px;\n  --space-5:  16px;\n  --space-6:  20px;\n  --space-7:  24px;\n  --space-8:  32px;\n  --space-9:  40px;\n  --space-10: 48px;\n  --space-12: 64px;\n  --space-16: 96px;\n\n  /* radius */\n  --radius-xs:   4px;\n  --radius-sm:   6px;\n  --radius-md:   8px;    /* inputs, buttons */\n  --radius-lg:   12px;   /* cards, menus */\n  --radius-xl:   16px;   /* large surfaces, modals */\n  --radius-2xl:  20px;\n  --radius-pill: 999px;\n\n  /* shadows — soft, cool-tinted, never harsh black */\n  --shadow-xs:  0 1px 2px rgba(15, 23, 42, 0.06);\n  --shadow-sm:  0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);\n  --shadow-md:  0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.04);\n  --shadow-lg:  0 12px 28px rgba(15, 23, 42, 0.12), 0 4px 10px rgba(15, 23, 42, 0.05);\n  --shadow-xl:  0 24px 48px rgba(15, 23, 42, 0.16), 0 8px 16px rgba(15, 23, 42, 0.06);\n  --shadow-focus: 0 0 0 3px var(--focus-ring);\n\n  /* layout */\n  --sidebar-width:     248px;\n  --topbar-height:     60px;\n  --container-max:     1440px;\n  --content-gutter:    24px;\n\n  /* control sizing */\n  --control-h-sm: 32px;\n  --control-h-md: 38px;\n  --control-h-lg: 44px;\n\n  /* motion */\n  --ease-out:   cubic-bezier(0.22, 1, 0.36, 1);   /* @kind other */\n  --ease-in-out: cubic-bezier(0.45, 0, 0.2, 1);   /* @kind other */\n  --dur-fast:   0.12s;   /* @kind other */\n  --dur-base:   0.18s;   /* @kind other */\n  --dur-slow:   0.28s;   /* @kind other */\n\n  /* z-index */\n  --z-sticky:  100;    /* @kind other */\n  --z-overlay: 1000;   /* @kind other */\n  --z-modal:   1010;   /* @kind other */\n  --z-toast:   1100;   /* @kind other */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
